import { useEffect, useRef, useState } from 'react';
import { styled, TextField } from '@mui/material';

const LinkStyled = styled('span')(({ theme }) => ({
    borderBottom: '1px dashed',
    cursor: 'pointer',
    '&:hover': {
        color: theme.palette.primary.main,
    },
}));

const EditStr = ({ value, onChange }) => {
    const [edit, setEdit] = useState(false);
    const [val, setVal] = useState(value);
    const inputRef = useRef(null);

    useEffect(() => {
        if (edit && inputRef.current) inputRef.current.focus();
    }, [edit]);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            setEdit(false);
            onChange(val);
        }
    };

    return edit ? (
        <TextField
            size="small"
            inputRef={inputRef}
            value={val}
            onChange={(e) => setVal(e.target.value)}
            onKeyDown={handleKeyDown}
            onBlur={() => {
                setEdit(false);
                onChange(val);
            }}
        />
    ) : (
        <LinkStyled onClick={() => setEdit(true)}>{value}</LinkStyled>
    );
};

export default EditStr;
